<template>
  <modal
    :show="show"
    @change="$emit('change', $event)"
    :headerClass="
      currentLocale === 'ru'
        ? 'bg-main-orange white--text helvetica-roman fs-18'
        : 'bg-main-orange white--text rubik-medium fs-18'
    "
    width="600"
  >
    <template v-slot:header>
      <span>{{ $t("modals.modalPaymentNew.client") }}</span>
    </template>
    <template v-slot:main>
      <div v-if="!paySuccess" class="modal-info text-center mx-7">
        <span class="d-block my-5 fs-16">
          <strong>
            {{ $t("modals.modalPaymentNew.info") }}
          </strong>
        </span>
        <!--  <div v-if="energyPay" class="text-left commission ml-2 fs-15">
      <span><strong>Комиссия банка:</strong> </span>
      <v-row class="fs-15" col="2">
        <v-col
          ><strong
            >По услуге электроснабжение <br> АО «Татэнергосбыт»:</strong
          ></v-col
        >
        <v-col><br /><strong>0 % </strong> по карте любого банка</v-col>
      </v-row>
      <v-row class="fs-15" col="2">
        <v-col><strong>По остальным услугам:</strong></v-col>
        <v-col
          ><strong>0 % </strong>по карте Ак Барс Банка<br /><strong
            >0,8 % </strong
          >по картам других банков</v-col
        >
      </v-row>
    </div>
    <div v-else class="text-left commission ml-10 pl-10">
      <span class="fs-14"
        ><strong>Комиссия банка:</strong> <br /><strong>0</strong> % - по картам
        ПАО «АК БАРС» Банк <br /><strong>0,8</strong> % - по картам других
        банков
      </span>
    </div> -->

        <div class="mt-3">
          <v-btn
            @click="GetBankUrl()"
            class="orange-button mb-5"
            :class="{ buttonFont: currentLocale === 'tat' }"
            :loading="loading"
          >
            {{ $t("buttons.pay") }}
          </v-btn>
        </div>
        <div class="left-con-table-pay">
          <span class="smaller-blue-text" style="color:dimgrey;">
            {{ $t("modals.modalPaymentNew.serviceInfoPart1") }}<br />{{ $t("modals.modalPaymentNew.serviceInfoPart2") }}
          </span>
          <div class="mt-3">
            <v-btn
              class="mb-5 green-button-pay"
              :class="{ buttonFont: currentLocale === 'tat' }"
              href="https://tatenergosbyt.ru/communal/how-pay/#banki"
            >
              {{ $t("modals.modalPaymentNew.go") }}
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="paySuccess" class="modal-info text-center mx-7 mt-10">
        <span class="d-block my-5 fs-18">
          {{ $t("modals.modalPaymentNew.serviceNotAvailable") }}
        </span>
        <v-btn @click="$emit('change', false)" class="orange-button mb-1 mt-5" :loading="loading"
          >{{ $t("buttons.close") }}
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";

export default {
  name: "ModalPayment",
  directives: {
    mask
  },
  components: {
    Modal
  },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    toPay: {
      required: true,
      type: [Number, String],
      default: 0
    },
    energyPay: {
      type: Boolean,
      default: false
    },
    details: {
      required: false,
      type: Array
    }
  },
  data: () => ({
    message: "",
    email: "",
    phone: "",
    sendTo: {
      email: false,
      phone: false
    },
    paySuccess: false,
    loading: false,
    valid: false,
    phoneRules: [
      v => !!v || "Номер телефона",
      v => /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(v) || "Введите корректный номер"
    ],
    emailRules: [
      v => !!v || "Введите e-mail",
      v => /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) || "Введены недопустимые символы",
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || "Введите корректный e-mail"
    ]
  }),
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapGetters("account", ["userSettings"]),
    ...mapGetters("locale", ["currentLocale"]),
    disabled() {
      if (this.sendTo.email) {
        return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email);
      } else if (this.sendTo.phone) {
        return !!/^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(this.phone);
      } else {
        return false;
      }
    }
  },
  methods: {
    GetBankUrl(testMode = false) {
      this.loading = true;
      let postData = {
        appVersion: "LKFL",
        personalAccount: this.selectedAccount.domHoz,
        idAccount:
          this.selectedAccount.isOwner === undefined || this.selectedAccount.isOwner
            ? this.userSettings.userGuid
            : this.selectedAccount.guid,
        paySum: this.toPay
      };
      AxiosWrapper.postForGetBankUrl("GetBankUrl", postData)
        .then(response => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.paySuccess = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {},
    telEncode(tel) {
      const encodedTel = "+" + tel.replace(/\D+/g, "");
      return encodedTel;
    }
  },
  created() {},
  watch: {},
  mounted() {}
};
</script>

<style lang="scss">
.green-button-pay {
  background: linear-gradient(rgb(57, 181, 74), rgb(0, 146, 69));
  color: white !important;
  font-family: HelveticaNeueCyr !important;
  font-weight: 500;
  text-transform: none !important;
  font-size: 16px !important;
  opacity: 0.7;
}
.left-con-table-pay {
}
.table-pay {
  display: flex;
}
.smaller-blue-text {
  display: block;
  margin-top: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: center;
  color: blue;
  font-size: 0.8em;
  font-weight: bold;
}
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }

  .commission {
    margin-left: 2110px;
    padding-left: 1000px;
  }
}
.buttonFont {
  font-family: Rubik-Medium !important;
}
</style>
